import styled from 'styled-components';

import { Card, Button, Text } from '@gympass/yoga';

export const UserInfoContainer = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: 100%;
  margin: 0 auto;
`;

export const HeaderInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const HeaderLabel = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const HeaderButtonChat = styled(Button)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
`;

export const TabsContainer = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const Divisor = styled.hr`
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.elements.lineAndBorders};
  margin: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const SessionsSection = styled(Card)`
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const SessionsContent = styled(Card.Content)`
  margin: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;
